import request from '@/utils/request.js'
import { V3 } from '@/utils/config.js'

export function getDashboard(params) {
    return request({
        url: '/'+ V3 +'/dashboard',
        method: 'get',
        params
    })
}

export function getStatusStats() {
    return request({
        url: '/'+ V3 +'/status-stats',
        method: 'get',
    })
}